import React, { Children } from 'react'
import Header from './Header';
import Footer from './Footer';
import Figure1 from '../images/figure1.svg'
import Figure2 from '../images/figure2.svg'
import Figure4 from '../images/figure4.svg'

export default function Container(
  {
    className = '',
    frontpageObject, 
    children
  }
  ){
    
    return(
      <>
        <div className={className + ' wrap'}>
          <img src={Figure1} className="figure-abs1 figure-abs1_main"></img>
          <img src={Figure2} className="figure-abs2 figure-abs2_main"></img>
          <img src={Figure4} className="figure-abs4 figure-abs4_main"></img>
          <div className="main">
            <Header  frontpageObject={frontpageObject} small={false}  />
            {
              children
            }
          </div>
          <Footer />
        </div>
      </>
    )
}
